import { animate, animation, query, stagger, style } from '@angular/animations'

export const fadeAnimation: any = animation(
  [
    style({
      opacity: '{{ from }}',
    }),
    animate(
      '{{ time }} ease-out',
      style({
        opacity: '{{ to }}',
      }),
    ),
  ],
  {
    params: {
      time: '0.6s',
      from: 0,
      to: 1,
    },
  },
)

export const fadeOutAnimation: any = animation(
  [
    style({ opacity: '{{ from }}' }),
    animate('{{ time }} ease-out', style({ opacity: '{{ to }}' })),
  ],
  {
    params: {
      time: '0.6s',
      from: 1,
      to: 0,
    },
  },
)

export const staggerAnimation: any = animation(
  [
    query('*', style({ opacity: 0 })),

    query('*', stagger('25ms', [animate('{{ time }}', style({ opacity: 1 }))])),
  ],
  {
    params: {
      time: '0.1s',
    },
  },
)

export const flyAnimation: any = animation(
  [
    style({
      opacity: '{{ opacityFrom }}',
      transform:
        'rotate3d({{ impactFrom }}, {{ impactFrom }}, 0, {{ angleFrom }}deg) scale({{ scaleFrom }})',
      transformStyle: 'preserve-3d',
    }),
    animate(
      '{{ time }} cubic-bezier(0.200, 1.300, 0.300, 1.400)',
      style({
        opacity: '{{ opacityTo }}',
        transform:
          'rotate3d({{ impactTo }}, {{ impactTo }}, 0, {{ angleTo }}deg) scale({{ scaleTo }})',
        transformStyle: 'preserve-3d',
      }),
    ),
  ],
  {
    params: {
      time: '2.5s',
      impactFrom: -1,
      impactTo: 1,
      angleFrom: 20,
      angleTo: 0,
      opacityFrom: 0,
      opacityTo: 1,
      scaleFrom: 0.95,
      scaleTo: 1,
    },
  },
)
